const motionSafe =
  'opacity-0 motion-reduce:translate-y-0 motion-reduce:opacity-100 motion-reduce:animate-none';

const points = [
  {
    title: 'Trusted Consultancy',
    text: 'Years of proven excellence with a reputation built on reliability, integrity, and successful outcomes for thousands of satisfied clients across the GCC.',
  },
  {
    title: 'Transparent Process',
    text: 'Complete visibility at every step with clear communication, honest guidance, and no hidden fees or surprises throughout your journey with us.',
  },
  {
    title: 'Fast Approvals',
    text: 'Streamlined processes and expert handling ensure quick turnaround times, minimizing delays and getting you results faster than industry standards.',
  },
  {
    title: 'Expert Team',
    text: 'Highly qualified professionals with deep industry knowledge and years of experience in immigration, education, IT, AI, Automation and corporate services.',
  },
  {
    title: 'Affordable Pricing',
    text: 'Competitive rates without compromising on quality, offering exceptional value for premium services that fit various budgets and requirements.',
  },
  {
    title: '24/7 Support',
    text: 'Round-the-clock customer service ensuring assistance whenever you need it, with dedicated support throughout your entire journey.',
  },
];

export default function WhyChooseUs() {
  return (
    <section
      className="relative border-t border-white/10 bg-gradient-to-b from-navy-900 to-navy-950 py-16 sm:py-24"
      aria-labelledby="why-heading"
    >
      <div
        className="pointer-events-none absolute inset-0 z-[1] bg-gradient-to-b from-navy-950/92 via-navy-900/82 to-navy-950/78"
        aria-hidden
      />
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold">Our Advantages</p>

          <h2
            id="why-heading"
            className={`mt-4 font-sans text-3xl font-bold tracking-tight text-white md:text-4xl ${motionSafe} animate-fade-in-up`}
          >
            Why Choose{' '}
            <span className="font-serif text-3xl font-semibold italic text-gold md:text-4xl">RAYAN STAR?</span>
          </h2>

          <p
            className={`mx-auto mt-4 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg ${motionSafe} animate-fade-in-up [animation-delay:80ms]`}
          >
            Our commitment to excellence makes us a trusted partner for thousands of clients
          </p>

          <div
            className={`mx-auto mt-5 h-px w-full max-w-md bg-gradient-to-r from-transparent via-gold/70 to-transparent ${motionSafe} animate-fade-in-up [animation-delay:120ms]`}
            aria-hidden
          />
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {points.map((p, i) => (
            <article
              key={p.title}
              className={`group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-7 text-center shadow-md transition duration-300 hover:-translate-y-1.5 hover:border-gold/45 hover:shadow-xl motion-reduce:hover:translate-y-0 ${motionSafe} animate-fade-in-up`}
              style={{ animationDelay: `${160 + i * 70}ms` }}
            >
              <div
                className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                style={{
                  background:
                    'radial-gradient(480px 220px at 50% 0%, rgba(212,175,55,0.14), transparent 55%)',
                }}
                aria-hidden
              />
              <div className="relative">
                <h3 className="font-serif text-xl font-semibold text-navy">{p.title}</h3>
                <p className="mt-3 text-justify text-sm leading-relaxed text-navy/70">{p.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
